import $ from "jquery";
import {DataLayer} from "./DataLayer";
import {LoginLayer} from "./LoginLayer";
import {SupportedPaymentMethods, Fines, GetFine, Ticket} from "../Api/Types";
import {NexyPayment, PaymentMethod, PayPalPayment, Response} from "./paymentMethods";

interface EnteResponse {
    code: string;
    ente: string;
}

export class FineDetailsLayer extends LoginLayer {
    private paymentMethod: PaymentMethod;
    private paymentName: SupportedPaymentMethods;
    private ente: string;
    private attribute_5: string | null;
    private license_plate: string | null;

    private CheckPaymentUrl = (e: string) => `https://${e}.babyloweb.eu/recuperi_api/testpayment.php`
    private NexyBabyloEndpoint = (e: string) => `https://${e}.babyloweb.eu/recuperi_api/nexi.php`
    private PayPalBabyloEndpoint = (e: string) => `https://${e}.babyloweb.eu/recuperi_api/paypal.php`

    private populateFinesDetailsTable(fines: Fines[]) {
        const tbody = $('#manage-batches-row-batch-list');
        for (const fine of fines) {
            const shipping_date: string = this.formatDateData(fine.shipping_date);

            const row = $(DataLayer.templates["manage-batches-row-manage-baches-template"]);
            row.find('[data-content-type="fines-details-table-row-id"]').text(fine.protocol_year);
            row.find('[data-content-type="fines-details-table-row-shipping-date"]').text(shipping_date);
            row.find('[data-content-type="fines-details-table-row-amount"]').text(Number(fine.fine_amount));

            row.find('#details-img').on('click', () => {
                this.onDetails(fine.smartprise_id);
            });

            tbody.append(row);
        }
    }

    private validateEmail(email: string | null = ""): boolean {
        // If no email is provided, fetch it from the #email-input element
        if (!email) {
            email = $('#email-input').val() as string;
        }

        // Check if the email is not empty and matches the regex pattern
        return this.email_regex.test(email);
    }

    private validateEmailAndHandleButton(page: JQuery<HTMLElement>) {

        if (!this.validateEmail()) {
            page.find('#load-ticket-history').css(this.disable_css).prop('disabled', true);
        } else {
            page.find('#load-ticket-history').css(this.enable_css).prop('disabled', false);
        }
    }

    private Listeners(page: JQuery ) {

        page.find('#email-input').on('input', () => {
            if (!this.validateEmail()) {
                $('#load-ticket-history').css(this.disable_css).prop('disabled', true);
            } else {
                $('#load-ticket-history').css(this.enable_css).prop('disabled', false)
            }
        })

        page.find('#load-ticket-history').on('click', () => {
            alert("oh you clicked the button!");
            const email_input = $('#email-input')
            const email = email_input.val() as string
            email_input.prop('readonly', true);
            this.OnLoadTicketHistory(email);
        });
    }

    private OnLoadTicketHistory(email: string) {
        this.client.get_tickets(email).done((tickets: Ticket[]) => {
            if (tickets.length > 0) {
                let i = 0
                const historial = $('#ticket-historial');
                for (const ticket of tickets) {

                    const historial_section = $(DataLayer.templates["response-ticket-div"]);
                    historial_section.prop('id', i);
                    historial_section.find('[data-content-type="ticket-response-ticket-title"]').text(ticket.title);
                    historial_section.find('[data-content-type="ticket-response-ticket-body"]').text(ticket.body);
                    historial_section.find('[data-content-type="ticket-response-ticket-link"]').prop('href', ticket.link);
                    historial_section.find('[data-content-type="ticket-response-ticket-number"]').text(ticket.number);
                    historial.append(historial_section);

                    i++
                }
                historial.animate({
                    scrollTop: $('#assistance-historial').height() // Use the ID to find the element and get its position
                }, 'smooth');

                // $('#assistance-historial').hide();

            } else {
                alert('No ticket yet');
            }
        })
    }

    private closeFineDetailDiv() {
        $('#fine-detail-div').css('display', 'none');
        $('#fines-details-container').css('display', '');
        $('#header-page').css('display', '');
    }

    private OnOpenTicket(fine: GetFine | null = null) {
        this.CreateTicketPopUp($('#assistance'), fine);
    }

    private createFineDetailPage(fine: GetFine) {
        const ente = this.getEnteName(fine.verbal_id);
        ente.done((response) => {

            this.ente = response.ente;

            let nameEnte: string = response.ente

            if (this.entiTrentino.includes(nameEnte)) {
                this.paymentName = SupportedPaymentMethods.PAYPAL;
            } else {
                this.paymentName = SupportedPaymentMethods.NEXY;
            }
            this.getPaymentMethod(this.paymentName);
            const fine_detail_div = $('#fine-detail-div')
            fine_detail_div.empty();
            fine_detail_div.css('display', '');
            $('#fines-details-container').css('display', 'none');
            $('#header-page').css('display', 'none');
            const img = $('#pay-image');

            // Create the new page content using the template
            const page = $(DataLayer.templates["fine-detail-template"]);

            // Populate the page with fine details
            page.find('[data-content-type="fine-detail-template-name"]').text(fine.name);
            page.find('[data-content-type="fine-detail-template-address"]').text(fine.address);
            page.find('[data-content-type="fine-detail-template-car_rental"]').text(fine.car_rental);
            page.find('[data-content-type="fine-detail-template-license_plate"]').text(fine.license_plate);
            if (fine.violation_date !== null)
                page.find('[data-content-type="fine-detail-template-violation_date"]').text(this.formatDateData(fine.violation_date));
            if (fine.violation_time !== null)
                page.find('[data-content-type="fine-detail-template-violation_time"]').text(this.formatTime(fine.violation_time));
            page.find('[data-content-type="fine-detail-template-violation"]').text(fine.violation);
            page.find('[data-content-type="fine-detail-template-violation-fine-amount"]').text(fine.fine_amount);
            page.find('[data-content-type="fine-detail-template-violation_location"]').text(fine.violation_location);
            page.find('[data-content-type="fine-detail-template-description"]').text(fine.description);

            // If there are attachments, set them as links
            if (fine.attachment_1 === null)
                page.find('[data-content-type="fine-detail-template-attachment_1"]').hide();
            else
                page.find('[data-content-type="fine-detail-template-attachment_1"]').prop("href", fine.attachment_1);
            if (fine.attachment_2 === null)
                page.find('[data-content-type="fine-detail-template-attachment_2"]').hide();
            else
                page.find('[data-content-type="fine-detail-template-attachment_2"]').prop("href", fine.attachment_2);

            // Set IBAN
            page.find('[data-content-type="fine-detail-template-iban"]').text(fine.iban);

            page.find('#close-details').on('click', () => {
                this.closeFineDetailDiv()
            })

            this.paymentMethod.isFinePaid(fine.verbal_id).done((response: Response) => {
                if (response.isPaid) {
                    page.find('[data-when="pay"]').hide();
                    page.find('[data-when="paying"]').hide();
                    page.find('[data-when="payed"]').show();

                    page.find('[data-content-type="fine-detail-payed-on"]').text(this.formatDateData(new Date("2025-02-04")))
                } else if (!fine.online_payment) {
                    page.find('[data-when="pay"]').hide();
                    page.find('[data-when="paying"]').hide();
                    page.find('[data-when="payed"]').hide();
                } else {
                    page.find('[data-when="pay"]').show();
                    page.find('[data-when="paying"]').hide();
                    page.find('[data-when="payed"]').hide();
                }
            });

            page.find('#open-ticket-page-button').on('click', () => {
                // this.CreateTicketPopUp($('#fine-detail-div'))
                const faq = $('body > div.sidebar > a:nth-child(3)');
                window.location.href = faq.prop('href');
            })

            page.on('click', '[data-role="pay"]', () => {
                page.find('[data-when="pay"]').hide();
                page.find('[data-when="paying"]').show();
                page.find('[data-content="paying"]').show();
                this.onPayment(fine.verbal_id, this.paymentName);
            });

            page.on('click', '[data-role="paying"]', () => {
                this.paymentMethod.isFinePaid(fine.verbal_id).done((response: Response) => {
                    if (response.isPaid) {
                        const today = new Date();
                        const day = String(today.getDate()).padStart(2, '0');
                        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                        const year = today.getFullYear();

                        const formattedDate = `${day}/${month}/${year}`;

                        page.find('[data-when="paying"]').hide();
                        page.find('[data-when="payed"]').show();
                        page.find('[data-content-type="fine-detail-payed-on"]').text(formattedDate)
                        // page.find('[data-content-type="fine-detail-payed-on"]').text(response.paymentDate)
                    } else {
                        page.find('[data-when="pay"]').show();
                        page.find('[data-when="paying"]').hide();
                        page.find('[data-content="paying"]').hide();
                    }
                });
            });

            // Append the new content to the fine-detail-div
            fine_detail_div.append(page);

            this.validateEmailAndHandleButton(page)
            this.Listeners(page);

            page.find('#open-ticket').on('click', () => {
                this.OnOpenTicket(fine);
            });

        }).fail((error) => {
            console.error('Failed to retrieve payment name', error);
            // Handle failure, possibly set a default or take some other action
            this.paymentName = SupportedPaymentMethods.NEXY; // Default fallback
        });
    }

    private getPaymentMethod(method: SupportedPaymentMethods): PaymentMethod {
        if (this.paymentMethod) {
            return this.paymentMethod;
        }

        if (method === SupportedPaymentMethods.NEXY) {
            return this.paymentMethod = new NexyPayment(this.NexyBabyloEndpoint(this.ente), this.CheckPaymentUrl(this.ente));
        } else if (method === SupportedPaymentMethods.PAYPAL) {
            return this.paymentMethod = new PayPalPayment(this.PayPalBabyloEndpoint(this.ente), this.CheckPaymentUrl(this.ente));
        }

        throw new Error("Invalid payment method");
    }

    private onPayment(verbale: string, method: SupportedPaymentMethods, redirect: boolean = true) {
        const paymentMethod = this.getPaymentMethod(method);
        if (paymentMethod instanceof NexyPayment) {
            paymentMethod.processPayment(verbale, redirect)
                .then(() => console.log("Payment processed successfully"))
                .catch((error) => console.error("Payment failed:", error));
        } else if (paymentMethod instanceof PayPalPayment) {
            let verbale = this.attribute_5;
            let targa = this.license_plate;
            paymentMethod.processPaymentInNewTab(verbale, targa);
        }
    }

    private getEnteName(verbale: string): JQuery.jqXHR<EnteResponse> {
        return $.post(this.RetireveEnteEndPoint, {
            IDVerbale: verbale,
        }, "json")
    }

    private onDetails(smartprise_id: number) {
        this.client.get_fine(smartprise_id).done((x: GetFine) => {
            this.attribute_5 = x.attribute_5;
            this.license_plate = x.license_plate;
            this.createFineDetailPage(x);
        });
    }

    protected OnFineDetails() {
        this.client.get_fines().done((x: Fines[]) => {
            this.populateFinesDetailsTable(x);
        })
    }
}